const NotifyDiscord = async (room, token, value, blob) => {

    const webhookUrl = `https://discord.com/api/webhooks/${room}/${token}`; // <-- ใส่ของคุณ

    try {

        const form = new FormData();
        if (blob) {
            form.append("file", blob, "slip.png"); // แนบภาพ
        }

        form.append("payload_json", JSON.stringify({ content: value }));

        const res = await fetch(webhookUrl, {
            method: "POST",
            body: form, // ไม่มี headers เพราะ FormData จะตั้ง multipart ให้เอง
        });

        if (!res.ok) {
            console.log('เกิดข้อผิดพลาดในการส่งข้อความ');
        }
    } catch (error) {
        console.error('Error:', error);
    }
}

export default NotifyDiscord